import { AppThunk } from '../states/generateStore';
import { suiteCrmUrl, getPricingOption } from './constants';
import shellSlice from '../states/shell/slice';
import snackBarSlice from '../states/snackbar/slice';
import { unescape } from '../helpers/suiteAdapter';

const getMultiProductFromApi = (index: number, lines: number, inputJson: any, search: string) => {
  let result: any[] = [];
  if (lines && lines > 0) {
    for (let i = 1; i <= lines; i++) {
      let obj = inputJson.hasOwnProperty(i) ? inputJson[i] : null;
      if (obj) {
        result = [
          ...result,
          {
            id: obj.id,
            partNumber: obj.partNumber,
            productName: obj.productName,
            qty: parseFloat(obj[`${search}${i}_${index}`])
          }
        ]
      }
    }
  }
  return result;
}

const onGetPricingOption = (option_quality: string): AppThunk =>
  async (dispatch, getStore) => {
    // get pricing option from API
    try {
      let response = await fetch(suiteCrmUrl.concat(getPricingOption).concat(option_quality), { method: 'GET' });
      let result = await response.text();
      if (result) {
        const resultJson = JSON.parse(unescape(result));
        
        let pricingOpt: any[] = [];
        for (let i = 1; i < 7; i++) {
            let tmpValue = {
              pm: resultJson[i].hasOwnProperty('pmbat_' + i) ? parseFloat(resultJson[i]['pmbat_' + i]) : 0,
              capacity: resultJson[i].hasOwnProperty('battery_storage_capacity_' + i) ? parseFloat(resultJson[i]['battery_storage_capacity_' + i]) : 0,
              products: getMultiProductFromApi(i, resultJson.main_line, resultJson[i].products, 'qty_main_bat'),
              accessories: getMultiProductFromApi(i, resultJson.accessory_line, resultJson[i].accessories, 'qty_accessory_bat'),
              installBat: resultJson[i].hasOwnProperty('install_bat_' + i) ? resultJson[i]['install_bat_' + i] : "",
              installStandard: resultJson[i].hasOwnProperty('install_standard') ? resultJson[i]['install_standard'] : "",
              extras: getMultiProductFromApi(i, resultJson.extra_line, resultJson[i].extras, 'qty_extra_bat'),
              grandTotalBat: resultJson[i].hasOwnProperty('grandtotal_bat_' + i) ? resultJson[i]['grandtotal_bat_' + i] : "",
              isSend: resultJson[i].hasOwnProperty('isSend') ? resultJson[i]['isSend'] : "",
              install_qty: resultJson[i].hasOwnProperty('install_qty') ? resultJson[i]['install_qty'] : "",
              peAdmin: resultJson.hasOwnProperty('battery_pe_admin_percent') ? resultJson['battery_pe_admin_percent'] : "",
            }
            pricingOpt = [...pricingOpt, tmpValue];
        }
        // console.log(pricingOpt);
        dispatch(shellSlice.actions.updatePricingOptions(pricingOpt));
       
      } else {
        // show warning
        dispatch(snackBarSlice.actions.updateAlert({message: "Unable to load Note template from Server", severity: "warning"}));
        dispatch(snackBarSlice.actions.updateSnackBar(true));
      }
    } catch (err) {
      console.log(err);
      // show error
      dispatch(snackBarSlice.actions.updateAlert({message: "onGetPricingOption: Can not get data from Server", severity: "error"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
  }
export default onGetPricingOption;